import React, { useId } from "react";

interface MobileCartIconProps {
  cartItemCount?: number;
  /** BattleKart route uses the orange brand gradient instead of the default aqua→magenta. */
  isBattleKart?: boolean;
}

export const MobileCartIcon: React.FC<MobileCartIconProps> = ({ cartItemCount = 0, isBattleKart = false }) => {
  const gradientId = useId().replace(/:/g, "");
  const showBadge = cartItemCount > 0;
  const badgeLabel = cartItemCount > 99 ? "99+" : String(cartItemCount);

  // BattleKart: vertical #ffe00b → #e63729. Default: horizontal aqua → magenta.
  const gradientDirection = isBattleKart ? { x1: "0%", y1: "0%", x2: "0%", y2: "100%" } : { x1: "0%", y1: "0%", x2: "100%", y2: "0%" };
  const gradientStops = isBattleKart
    ? [
        { offset: "0%", color: "#ffe00b" },
        { offset: "100%", color: "#e63729" },
      ]
    : [
        { offset: "0", color: "aqua" },
        { offset: "1", color: "#f0f" },
      ];
  // Match the session pill counter: black background with the brand-colored border.
  const badgeBorderColor = isBattleKart ? "#e63729" : "#f0f";

  return (
    <span className="tw-relative tw-inline-flex tw-h-[40px] tw-w-[40px] tw-shrink-0 tw-overflow-visible">
      <svg width="40" height="40" className="tw-h-[40px] tw-w-[40px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" aria-hidden="true">
        <defs>
          <linearGradient id={gradientId} {...gradientDirection}>
            {gradientStops.map((stop) => (
              <stop key={stop.offset} offset={stop.offset} stopColor={stop.color} />
            ))}
          </linearGradient>
        </defs>

        <circle cx="20" cy="20" r="20" fill="#000" />
        <circle cx="20" cy="20" r="17.09" fill="none" stroke={`url(#${gradientId})`} strokeWidth="2.91" />

        <path
          d="M12.52,21.02l3.04-7.48c.14-.35.48-.58.86-.58l13.03.05c.37,0,.87.24.76.84l-2.79,7.71c-.33.72-.67.74-1.33.74h-13.15c-.93,0-.66-.66-.41-1.27ZM17.02,24.72c-.75,0-1.37.61-1.37,1.37s.61,1.37,1.37,1.37,1.37-.61,1.37-1.37-.61-1.37-1.37-1.37ZM24.52,26.04c0,.75-.61,1.37-1.37,1.37s-1.37-.61-1.37-1.37.61-1.37,1.37-1.37,1.37.61,1.37,1.37ZM11.22,21.96l3.32-8.13c.25-.61-.2-1.28-.86-1.28h-2.65c-.6,0-.6.91,0,.91h2.05c.66,0,.52.26.26.87l-3.16,7.63c-.4.85.24,2.01,1.28,2.01h14.75c.67,0,.67-.88,0-.88h-14.14c-.66,0-1.11-.51-.86-1.12Z"
          fill={`url(#${gradientId})`}
        />

        <line x1="25.27" y1="19.85" x2="26.7" y2="15.72" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" />
        <line x1="15.97" y1="19.7" x2="17.43" y2="15.44" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" />
        <line x1="20.83" y1="19.85" x2="22.22" y2="15.72" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      {showBadge && (
        <span
          className="tw-pointer-events-none tw-absolute tw-right-0 tw-top-0 tw-z-[50] tw-flex tw-h-[16px] tw-min-w-[16px] tw-items-center tw-justify-center tw-rounded-full tw-border tw-bg-black tw-px-[3px] tw-text-[9px] tw-font-bold tw-leading-none tw-text-white"
          // -4px overhang = footer pill height (44px) minus icon height (40px), so badge top meets pill top.
          style={{ transform: "translate(10%, -2px)", borderColor: badgeBorderColor }}
        >
          {badgeLabel}
        </span>
      )}
    </span>
  );
};
